export default "__VITE_ASSET__CLHSTKAh__"